let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("66xpX")).then(() => parcelRequire('6EsK2'));